import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { PageHeader } from "../../layout/AppLayout";
import { ErpTable } from "../../components/erp";
import { errorText } from "../../api/client";
import { RmAnalysisRow, rmAnalysisApi } from "./api";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

/** Port of v3/QualityControl/Ajax/AjaxRm_analysis.php (list) — per-lot AB status + organic-check progress. */
export default function RmAnalysisList() {
  const now = new Date();
  const [month, setMonth] = useState(String(now.getMonth() + 1));
  const [year, setYear] = useState(String(now.getFullYear()));
  const list = useQuery({ queryKey: ["qc", "analysis", month, year], queryFn: () => rmAnalysisApi.list({ Month: month, Year: year }) });

  return (
    <>
      <PageHeader title="RM Analysis" location="Quality Control" />
      <div className="card"><div className="card-body">
        <div className="row rowFilter mb-3">
          <div className="col-md-3">
            <select className="form-select" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="rm-analysis-month">
              {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
            </select>
          </div>
          <div className="col-md-3">
            <input className="form-control" type="number" value={year} onChange={(e) => setYear(e.target.value)} data-testid="rm-analysis-year" />
          </div>
        </div>
        <ErpTable<RmAnalysisRow> testId="rm-analysis-table" loading={list.isLoading}
          error={list.isError ? errorText(list.error) : list.data?.Error || null}
          rows={list.data?.Data || []}
          columns={[
            { key: "LotNumber", title: "Lot Number" },
            { key: "PurchaseDate", title: "Purchase Date" },
            { key: "PurchaseType", title: "Type" },
            { key: "PurchaseCount", title: "Count" },
            { key: "PurchaseWeight", title: "Weight" },
            { key: "AbStatus", title: "AB Status", render: (r) => <span className="statusPending" style={{ background: r.AbColour, minWidth: 90 }}>{r.AbStatus}</span> },
            { key: "Status", title: "Status", render: (r) => <span className="statusPending" style={{ background: r.StatusColour, minWidth: 120 }}>{r.Status}</span> },
            { key: "Remarks", title: "Remarks" },
            { key: "Action", title: "Action", render: (r) => (
              r.Action === "add" ? <Link className="btn btn-sm btn-primary" data-testid={`rm-analysis-add-${r.RmLotID}`} to={`/v3/QualityControl/RmReportCreate?LotId=${r.RmLotID}`}>Add ({r.OrgnDetailsPreview}/3)</Link>
              : r.Action === "preview" ? <Link className="btn btn-sm btn-success" data-testid={`rm-analysis-preview-${r.RmLotID}`} to={`/v3/QualityControl/RmAnalysisPreview?LotId=${r.RmLotID}`}>Preview</Link>
              : <span className="text-muted" data-testid={`rm-analysis-print-${r.RmLotID}`}>Verified</span>
            ) },
          ]} />
      </div></div>
    </>
  );
}
